import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'
import VueSweetalert2 from 'vue-sweetalert2'
import VueApexCharts from 'vue-apexcharts'
import VueTour from 'vue-tour'
import Vuelidate from 'vuelidate'
import KnobControl from 'vue-knob-control'
import VueDraggable from 'vue-draggable'
import * as VueGoogleMaps from 'vue2-google-maps'
import VueMask from 'v-mask'
import VueStringFilter from 'vue-string-filter'
import vco from "v-click-outside"
import VueCookie from 'vue-cookie';

import App from './app'
import router from '@router'
import store from '@state/store'
import '@components/_globals'
// import card from '@components/card/card'
// import cardHeader from '@components/card/card-header'
import upperFirst from 'lodash/upperFirst'
import camelCase from 'lodash/camelCase'
import { simpleMethods } from '@state/helpers'
import responsive from 'responsive'

// Don't warn about using the dev version of Vue in development.
Vue.config.productionTip = process.env.NODE_ENV === 'production'

// If running inside Cypress...
if (process.env.VUE_APP_TEST === 'e2e') {
  // Ensure tests fail when Vue emits an error.
  Vue.config.errorHandler = window.Cypress.cy.onUncaughtException
}

Vue.use(vco)

Vue.use(VueStringFilter)
Vue.use(BootstrapVue)
Vue.use(VueSweetalert2)
Vue.use(Vuelidate)
Vue.use(VueTour)
Vue.use(KnobControl)
Vue.use(VueDraggable)
Vue.use(VueMask)
Vue.use(require('vue-chartist'))
Vue.use(VueCookie)

Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyAbvyBxmMbFhrzP9Z8moyYr6dCr-pzjhBE',
    libraries: 'places',
  },
  installComponents: true
})
Vue.component('apexchart', VueApexCharts)

const requireComponent = require.context(
  // 컴포넌트들이 있는 폴더
  './components/form',
  // 하위 폴더까지 포함할 지 여부
  false,
  // 기본 컴포넌트를 찾는데 사용할 정규표현식
  /[A-Z]\w+\.(vue|js)$/
)

requireComponent.keys().forEach(fileName => {
  // 컴포넌트 설정 가져오기
  const componentConfig = requireComponent(fileName)

  // 컴포넌트의 파스칼표기법 이름 가져오기
  const componentName = upperFirst(
    camelCase(
      // 폴더 위치와 무관하게 파일이름 추출
      fileName
        .split('/')
        .pop()
        .replace(/\.\w+$/, '')
    )
  )

  // 컴포넌트를 전역적으로 등록
  Vue.component(
    `C.${componentName}`,
    // `export default`를 이용한 컴포넌트는 `.default`로 컴포넌트
    // 옵션을 추출하고 그렇지 않은 컴포넌트는 모듈의 루트를 호출
    componentConfig.default || componentConfig
  )
})
// Vue.component('card', card);
// Vue.component('card-header', cardHeader);
// Uncomment this if you are having api served through other url
// Vue.prototype.$http = require('axios')
// Vue.prototype.$http.defaults.baseURL  = 'http://mock-api.coderthemes.com'

Vue.mixin({
	methods : {
		...simpleMethods
	},
	created() {
		const opts = {
			checkpoints: {
				small: {
					width: [0, 800]
				},
				big: {
					width: [801, null]
				}
			}
		};

		responsive(opts, data => {
			// This callback fires immediately and whenever the window size changes
			this.setWideMode(data.matches[0] === 'big');
		})
	}
});

/* eslint no-extend-native: ["off"] */
String.prototype.replaceAll = function(regex, replacement) {
	return this.split(regex).join(replacement);
};
/* eslint no-extend-native: ["off"] */
String.prototype.toInt = function(regex, replacement) {
	return parseInt(this.replaceAll(',', ''));
};
/* eslint no-useless-concat: ["off"] */
String.prototype.toComma = function() {
	let reg = /(^[+-]?\d+)(\d{3})/;
	let num = this;
	while(reg.test(num))
		num = num.replace(reg, '$1' + ',' + '$2');
	return num;
};
Number.prototype.toComma = function() {
	return (this + '').toComma();
};


const app = new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app')

// If running e2e tests...
if (process.env.VUE_APP_TEST === 'e2e') {
  // Attach the app to the window, which can be useful
  // for manually setting state in Cypress commands
  // such as `cy.logIn()`.
  window.__app__ = app
}

